require('./LandingPages/components').default;

Vue.component('direct-app-debug', require('./Application/Tests/vue/direct-app-debug').default);
Vue.component('jobboard-employer-profile', require('./EmployerProfile/vue/jobboard-employer-profile.vue').default);
